<template>

  <div>

    <!-- Labels for text inputs with add-ons must be placed before the field -->
    <!-- container in order to appear above the input, rather than inline.   -->
    <label v-if="label && hasAddons" class="label" :for="id" v-html="label" />

    <Field
      :name="id" 
      :rules="rules"
      :modelValue="modelValue"
      v-slot="{ field, errors }"
      :validateOnInput="true"
    >
      <div class="field" :class="{ 'has-addons': hasAddons }">
        <label v-if="label && !hasAddons" class="label" :for="id">
          <span v-html="label"></span>
          <RequiredAsterisk v-if="rules.includes('required')" />
        </label>

        <div class="control" :class="{ 'is-expanded': hasAddons }">

          <!-- Prevent Enter key from submitting forms, but allow custom events -->
          <input
            type="text"
            class="input"
            autocomplete="off"
            :class="{ 'is-danger': errors.length }"
            v-bind="field"
            @input="updateValue($event.target.value)"
            :disabled="disabled"
            :maxlength="maxlength"
            :placeholder="placeholder"
            :aria-invalid="errors.length > 0"
            :aria-errormessage="`${id}Err`"
            @keydown.enter.prevent="customKeydownEnter && field.value && !errors.length ? $emit('keydown-enter') : null"
          />

          <!-- Validation message -->
          <p v-if="errors.length" class="help is-danger" :id="`${id}Err`">
            {{ errors[0] }}
          </p>

        </div>

        <slot name="addons" />
      </div>
    </Field>

  </div>

</template>

<script>
import { Field } from 'vee-validate';
import RequiredAsterisk from '@/components/forms/required-asterisk.vue';

export default {
  name: 'TextInputElement',
  props: {
    id: {
      type: String,
      required: true,
      validator: value => value.length,
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    rules: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number,
      default: 255
    },
    modelValue: { 
      type: [String, Number], 
      default: '' 
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    customKeydownEnter: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'input', 'keydown-enter'],
  computed: {
    hasAddons() {
      return !!this.$slots.addons;
    },
  },
  methods: {
    updateValue(value) {
      // this.$emit('input', value);
      this.$emit('update:modelValue', value); 
      this.$emit('input', value); 
    },
  },
  components: {
    RequiredAsterisk,
    Field,
  },
};
</script>